import { IComboBoxOption, IIconProps } from "@fluentui/react";
import TimeTaxSupportSystemClient from "../../system";
import MessageCourier from "../../lib/MessageCourier";
import { User } from "../../system/User";
import { IActivityRecurring, ItipoConcepto } from "../../system/projects/ProjectsSystem";
import { DateTime } from "luxon";

export interface ICompanyPanel {
    system: TimeTaxSupportSystemClient;
    courier: MessageCourier;
    changeBlockUI: (change: boolean) => void;
    user: User;
    useAllSector?: boolean;
    loading?: boolean;
  };
export interface IAddRows {
    id: string;
    nombrePro: IComboBoxInput;
    nombreAct: string;
    horasCarg: string;
    file: string;
    files: File[];
    valida: number;
    descripcionError: string;
    actividadRecurrente: string;
    lisActRecurrente: IActivityRecurring[];
    actividadRecurrenteSelect?:IActivityRecurring;
    tipoConcepto:ItipoConcepto;
    listaProyectos:IComboBoxOption[];
    filterListProyectos:IComboBoxInput[];
    descripcion:string;
    paisEmpresa:IComboBoxInput,
    nombreEmp:IComboBoxInput,
    listaEmpresa:IComboBoxOption[],
    options: any
}

export interface IactError {
  actVali:number;
  actvErro:number;
}

export interface ICollaborator {
  id: string;
  name: string;
  lastName: string;
  email: string;
  active: boolean;
}

export interface IComboBoxInput extends IComboBoxOption{
  code?: string;
  pro_inicio?: DateTime
  pro_fin?: DateTime;
}


   export const UploadIcon: IIconProps = { iconName: 'Upload' };
   export const AddIcon: IIconProps = { iconName: 'add' };